import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FaqSection } from './components/FaqSection';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/meta-pixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-white font-sans text-charcoal selection:bg-forest/20 selection:text-forest" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <OpeningHook data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <FailedSolutions data-id="element-5" />
        <UniqueMechanism data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <WhoIsThisFor data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <ProofSection data-id="element-10" />
        <FaqSection data-id="element-11" />
        <OfferBlock data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}